import React from 'react'

import ProjectList from '../Components/ProjectList'

import Footer from '../Components/Footer'

import AppearOnScroll from '../Components/AppearOnScroll'
import Navigation from '../Components/Navigation'

export default function ProjectOverview() {
    return (
      <AppearOnScroll>
        <div className='min-h-screen flex flex-col'>
        <Navigation/>
        <div className="flex flex-col pt-32 md:pt-48 xl:pt-52 px-4 lg:px-24 xl:px-48 gap-8 md:gap-20 pb-24 w-full overflow-x-hidden">
          <div className='flex flex-col items-start text-left w-full'>
            <h1 className='font-display font-medium leading-medium text-3xl lg:text-5xl xl:text-7xl text-dark text-wrap text-left cursor-default'>All projects</h1>
          </div>
          <ProjectList/>
        </div>

        <Footer/>
        </div>
      </AppearOnScroll>
    )
  }